export default __webpack_public_path__ + "static/media/starsbackground.74df00d5.jpg";